import { APICfg } from 'services/api/api'
import { getId } from 'services/utils'
import { APIRule, Rule, RuleProduct, RuleToAPI } from '../Rules'

const apiCfg: APICfg = {
  endpoint: 'rule',
  parse: (res: APIRule): Rule => ({
    ...res,
    if: res.if.map(mapIdsFromProducts),
    then: res.then.map(mapIdsFromProducts),
  }),
  write: async (req: Rule): Promise<RuleToAPI> => req,
}

type WithProducts = { products: RuleProduct[] }

/**
 * @param obj with products records array
 * @returns the same object with products number []
 */
const mapIdsFromProducts = <T extends WithProducts>(obj: T) => ({
  ...obj,
  products: obj.products.map(getId),
})

export default apiCfg
